import { CompetitorType } from "../brief/types";

const removeOutliers = (competitors: CompetitorType[]) => {
  const sortedCompetitors = competitors.sort(
    (a, b) => b.wordCount - a.wordCount
  );
  if (
    sortedCompetitors?.[0]?.wordCount >=
    3 * sortedCompetitors?.[1]?.wordCount
  ) {
    sortedCompetitors.shift();
  }
  return sortedCompetitors;
};

export const calculateSuggestedData = (competitors: CompetitorType[]) => {
  const filteredCompetitors = competitors.filter(
    (competitor) =>
      competitor.type === "organic" &&
      competitor.wordCount > 0 &&
      competitor.headings.length > 0
  );

  const competitorsWithoutOutliers = removeOutliers(filteredCompetitors);

  const reducedCompetitors = competitorsWithoutOutliers.reduce(
    (acc, item, index) => {
      return {
        ...acc,
        wordCount: acc.wordCount + item.wordCount,
        headings: acc.headings + item.headings.length,
        images: index < 5 ? acc.images + item.images.length : acc.images,
      };
    },
    { wordCount: 0, headings: 0, images: 0 }
  );

  const recommendedWordCount =
    reducedCompetitors.wordCount / competitorsWithoutOutliers.length;

  const wordCount =
    Math.round(
      (recommendedWordCount +
        recommendedWordCount / competitorsWithoutOutliers.length) /
      100
    ) * 110;

  return {
    wordCount,
    headings: Math.round(
      reducedCompetitors.headings / competitorsWithoutOutliers.length
    ),
    images: Math.round(wordCount / 350),
  };
};
